const colors = {
  BLACK: '#000000',
  WHITE: '#ffffff',
  GOLD: '#e1af5f',
  TEAL: '#00819B',
  TEAL_INTENSIVE: '#026275',
  TEAL_LIGHT: '#C0F4FF',
  LIGHT_GREY: '#F5F5F5',
  GREY: '#808080',
  DARK_GREY: '#4A4A4A',
  LIGHT_BLUE: '#399dff',
  GREEN: '#8bc34a',
  DANGER: '#d0021b',
  FORM_GREY: '#AFAFAF',
  BORDER_GREY: '#E0E0E0',
  DASHBOARD_DISABLED_GREY: '#C9C9C9',
};

export default {
  ...colors,
  PRIMARY: colors.TEAL,
  INTENSIVE: colors.TEAL_INTENSIVE,
  LIGHT: colors.TEAL_LIGHT,
  LINK: colors.LIGHT_BLUE,
  SECONDARY: colors.WHITE,
  SUCCESS: colors.GREEN,
  TEXT: colors.DARK_GREY,
};



// WEBPACK FOOTER //
// ./theme/colors.js